<template>
  <v-card>
    <v-card-title>
      <span class="headline">List Merchant</span>
    </v-card-title>

    <v-card-text>
      <v-card class="d-flex pa-2 flex-column" outlined>
        <v-alert
          v-model="flashError"
          dense
          border="left"
          type="error"
          dismissible
          elevation="2"
        >
          {{ flashErrorMessage }}
        </v-alert>
        <v-data-table
          :headers="headers"
          fixed-header
          :items="allData"
          :options.sync="options"
          :server-items-length="totalData"
          :loading="loading"
          loading-text="Loading... Please wait"
          :item-class="rowClass"
          class="d-print-table"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 25, 50],
          }"
          item-key="trx_id"
          sort-by="id"
          :sort-desc="true"
          :style="{ padding: '10px', height: '70vh' }"
        >
          <template v-slot:[`body.prepend`]>
            <merchant-promo-filter
              :search="search"
              v-on:getDataParent="getDataMerchantPromo"
            />
          </template>
          <template v-slot:item="{ item, index }">
            <merchant-promo-item-vue
              :options="options"
              :selectedRow="selectedRow"
              :item="item"
              :index="index"
              v-on:selectRowParent="selectRow"
            />
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  components: {
    MerchantPromoItemVue: () => import('../table/MerchantPromoItem.vue'),
    MerchantPromoFilter: () => import('../table/MerchantPromoFilter.vue'),
  },
  props: ['promoId'],

  data: () => ({
    isFirstLoad: false,
    options: {},
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        sortable: false,
        width: '10',
      },
      {
        text: 'MID',
        value: 'mid',
        width: '200',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Nama Merchant',
        value: 'merchant_name',
        width: '150',
        align: 'center',
        sortable: false,
      },
    ],
    search: {
      mid: '',
    },
    selectedRow: '',
    editedIndex: -1,
  }),

  computed: {
    allData() {
      return this.$store.state.promo.allDataMerchantPromo;
    },
    totalData() {
      return this.$store.state.promo.totalDataMerchantPromo;
    },
    totalPage() {
      return this.$store.state.promo.totalPageMerchantPromo;
    },
    loading() {
      return this.$store.state.promo.loading;
    },

    flashError: {
      get() {
        return this.$store.state.promo.flashError;
      },
      set() {
        this.$store.commit('promo/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.promo.flashErrorMessage;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getDataMerchantPromo();
        } else {
          this.$store.commit('promo/clearDataMerchantPromo');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    promoId() {
      if (this.promoId) this.getDataMerchantPromo();
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getDataMerchantPromo() {
      this.$store.commit('promo/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('promo/getMerchantPromo', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          promoId: this.promoId,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    close() {
      this.$emit('closeParent');
    },

    clearSearch() {
      this.search.mid = '';
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
